"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchLI = exports.matchL = exports.matchPI = exports.matchP = exports.matchI = exports.match = void 0;
/**
 * Pattern matching for a sum type defined with ADT
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * pipe(
 *   foo,
 *   match({
 *     none: () => 'none',
 *     some: ({value}) => 'some'
 *   })
 * )
 * ```
 */
function match(matchObj) {
    return (v) => matchObj[v._tag] != null
        ? matchObj[v._tag](v)
        : matchObj['_'](v);
}
exports.match = match;
/**
 * Partial pattern matching for a sum type defined with ADT
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * pipe(
 *   foo,
 *   match({
 *     some: ({value}) => 'some'
 *     _: (_option) => 'none',
 *   })
 * )
 * ```
 */
function matchP(matchObj) {
    return (v) => matchObj[v._tag] != null
        ? matchObj[v._tag](v)
        : matchObj['_'](v);
}
exports.matchP = matchP;
/**
 * Pattern matching for an string liternal (`matchL`)
 *
 *
 * ```ts
 * declare const foo: 'student' | 'teacher' | 'admin'
 *
 * pipe(
 *   foo,
 *   matchL({
 *     student: () => 'Murid'
 *     teacher: () => 'Guru',
 *     admin: () => 'Admin',
 *   })
 * )
 * ```
 */
function matchL(matchObj) {
    return (v) => matchObj[v]();
}
exports.matchL = matchL;
/**
 * Item-first version of match, useful for better inference in some circumstances
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * matchI(foo)({
 *   none: () => 'none',
 *   some: ({value}) => 'some'
 * })
 * ```
 */
function matchI(v) {
    return (matchObj) => matchObj[v._tag](v);
}
exports.matchI = matchI;
/**
 * Item-first version of matchP, useful for better inference in some circumstances
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * matchP(foo)({
 *   some: ({value}) => 'some'
 *   _: (_option) => 'none',
 * })
 * ```
 */
function matchPI(v) {
    return (matchObj) => matchObj[v._tag] != null
        ? matchObj[v._tag](v)
        : matchObj['_'](v);
}
exports.matchPI = matchPI;
/**
 * Item-first version of matchL, useful for better inference in some circumstances
 *
 * ```ts
 * declare const foo: 'student' | 'teacher' | 'admin'
 *
 * matchP(foo)({
 *   student: () => 'Murid'
 *   teacher: () => 'Guru',
 *   admin: () => 'Admin',
 * })
 * ```
 */
function matchLI(v) {
    return (matchObj) => matchObj[v]();
}
exports.matchLI = matchLI;
